var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("Startups")]),_c('v-card-text',[_c('v-btn',{attrs:{"to":"/startups/bit-defenders"}},[_vm._v("Bit Defenders")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }